import React, { useState } from "react";
import { Button, Flex, Form, Input, Modal, notification } from "antd";
import CustomerApi from "../../api-services/customer-api.service";
import { useAuth } from "../../services/AuthContext";

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!'
  },
};

type FieldType = {
  email?: string;
  password?: string;
};

const SignInForm: React.FC<{ onSuccess?: () => void }> = ({ onSuccess }) => {
  const { login } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [forgotPasswordModalVisible, showForgotPasswordModal] = useState(false);

  const closeModal = () => {
    showForgotPasswordModal(false);
  };

  const sendRequest = (formValues: { email: string }) => {
    CustomerApi.forgotPassword(formValues.email)
      .then(success => {
        if (success) {
          closeModal();
          Modal.success({
            content: "If your email exists in our database, you will receive a password recovery link at your email address in a few minutes."
          });
        }
      })
      .catch(error => {
        notification.error({ message: error.response?.data?.error || error.message || "An error occurred" });
      });
  };

  const handleFinish = (values: FieldType) => {
    setSubmitting(true);
    login(values)
      .then(() => onSuccess?.())
      .catch(() => { /* already toasted inside login() */ })
      .finally(() => setSubmitting(false));
  };

  return (
    <>
      <Form
        autoComplete="off"
        layout="vertical"
        variant="filled"
        onFinish={handleFinish}
        className="sign-in-form"
      >
        <Form.Item<FieldType>
          label="Email Address"
          name="email"
          rules={[{ required: true, message: 'Please input your email address' }, { type: "email" }]}
        >
          <Input placeholder="Enter Email Address" />
        </Form.Item>

        <Form.Item<FieldType>
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password' }]}
        >
          <Input.Password placeholder="Enter Password" />
        </Form.Item>

        <p id="forgot-password" onClick={() => showForgotPasswordModal(true)}>forgot Password?</p>

        <Flex align="center" justify="center">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Sign In
          </Button>
        </Flex>
      </Form>

      <Modal title={
        <>
          <h2>Forgot Password</h2>
          <p>To reset your password, please enter your email address</p>
        </>
      } open={forgotPasswordModalVisible} onCancel={closeModal} footer={null} width={800} centered className="forgot_password_modal">
        <Form
          autoComplete="off"
          layout="vertical"
          variant="filled"
          validateMessages={validateMessages}
          onFinish={sendRequest}
          className="forgot-password-form"
        >
          <Form.Item label="Email" name="email" required>
            <Input placeholder="Enter Email" />
          </Form.Item>

          <Flex align="center" justify="center">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  );
};

export default SignInForm;
